import { Play, Pause, SkipBack, SkipForward, Mic, Captions } from "lucide-react";

export const Hud = ({ slide, total, phase, micLive, captionsOn, onToggleCaptions, onTogglePlay, onPrev, onNext, onAsk }) => {
  const playing = phase === "narrating";
  return (
    <div className="fixed bottom-0 left-0 right-0 z-30 border-t border-neutral-800 bg-black/70 backdrop-blur-xl">
      <div className="h-px w-full bg-neutral-900">
        <div
          className="h-px bg-[#dd6611] transition-[width] duration-700"
          style={{ width: `${((slide + 1) / total) * 100}%` }}
        />
      </div>
      <div className="flex items-center gap-3 sm:gap-6 px-4 sm:px-10 py-3">
        <span className="font-mono text-[10px] sm:text-[11px] tracking-[0.25em] text-neutral-500">
          {String(slide + 1).padStart(2, "0")} / {String(total).padStart(2, "0")}
        </span>
        <div className="flex items-center gap-1 sm:gap-2">
          <button data-testid="prev-slide-btn" onClick={onPrev} disabled={slide === 0}
            className="p-2 text-neutral-400 hover:text-white transition-colors duration-200 disabled:opacity-30">
            <SkipBack size={15} strokeWidth={1.5} />
          </button>
          <button data-testid="toggle-play-btn" onClick={onTogglePlay}
            className="p-2 border border-neutral-700 text-white hover:border-[#dd6611] transition-colors duration-200">
            {playing ? <Pause size={15} strokeWidth={1.5} /> : <Play size={15} strokeWidth={1.5} />}
          </button>
          <button data-testid="next-slide-btn" onClick={onNext} disabled={slide === total - 1}
            className="p-2 text-neutral-400 hover:text-white transition-colors duration-200 disabled:opacity-30">
            <SkipForward size={15} strokeWidth={1.5} />
          </button>
        </div>
        <div className="flex-1" />
        <button
          data-testid="toggle-captions-btn"
          onClick={onToggleCaptions}
          title={captionsOn ? "Hide captions" : "Show captions"}
          className={`p-2 border transition-colors duration-200 ${
            captionsOn ? "border-[#dd6611] text-[#dd6611]" : "border-neutral-700 text-neutral-500 hover:text-white"
          }`}
        >
          <Captions size={15} strokeWidth={1.5} />
        </button>
        <div className="hidden sm:flex items-center gap-2">
          <span className={`w-1.5 h-1.5 rounded-full ${micLive ? "bg-[#dd6611] pulse-dot" : "bg-neutral-700"}`} />
          <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-neutral-500">
            {micLive ? "Xena is listening" : "Questions at the end"}
          </span>
        </div>
        <button
          data-testid="ask-question-btn"
          onClick={onAsk}
          className="flex items-center gap-2 border border-neutral-700 px-3 sm:px-4 py-2 font-mono text-[10px] tracking-[0.2em] uppercase text-neutral-300 hover:border-[#dd6611] hover:text-white transition-colors duration-200"
        >
          <Mic size={12} strokeWidth={1.5} /> <span className="hidden sm:inline">Ask a question</span><span className="sm:hidden">Ask</span>
        </button>
      </div>
    </div>
  );
};
